import { RepeatIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { AvisosUpdate } from "components/mailing-components/avisos";
import {
  GenerateMailingModal,
  openModalGenerateMailing
} from "components/mailing-components/mailing-modal-filter";
import { MailingOptionsModal } from "components/mailing-components/mailing-options-modal";
import {
  MailingsTable,
  useMailingsData
} from "components/mailing-components/mailing-table";
import {
  MailingUploadModal,
  openModalMailingUpload
} from "components/mailing-components/mailing-upload-modal";
import { SendForCleaningModal } from "components/mailing-components/send-for-cleaning-modal";
import { ContactListIcon } from "components/vectors/contact-list-icon";
import { UploadIcon } from "components/vectors/upload-icon";
import { makeEvent } from "services/events";
import { RoutePermissionFunction } from "router-manager/parts";

export default function MailingPage() {
  const mailingsData = useMailingsData();

  return (
    <GetLayout
      title="Mailing"
      rightContent={
        <Flex>
          <Button
            mr="8px"
            leftIcon={<ContactListIcon />}
            onClick={() => openModalGenerateMailing()}
          >
            Gerar Mailing
          </Button>
          <Button
            mr="8px"
            onClick={() => openModalMailingUpload()}
            leftIcon={<UploadIcon />}
          >
            Upload Mailing
          </Button>
          <Button
            onClick={() => {
              updateMailingsTable();
            }}
            leftIcon={<RepeatIcon />}
            isLoading={mailingsData.isLoading}
            loadingText="Atualizando"
          >
            Atualizar
          </Button>
        </Flex>
      }
    >
      <AvisosUpdate />
      <MailingsTable {...mailingsData} />
      <GenerateMailingModal />
      <MailingUploadModal />
      <MailingOptionsModal />
      <SendForCleaningModal />
    </GetLayout>
  );
}

export const updateMailingsTable = () => makeEvent("update-mailings-table");

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission([
    "SUPER",
    "REGIONAL",
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_MASTER",
    "ASCOM"
  ]);
  route.setColomboUserTypesPermission([
    "COMERCIAL",
    "PARCEIRO_MASTER",
    "PARCEIRO_VENDEDOR"
  ]);
};
